export type CollectReason = "Do Not Collect" | "Optional" | "Required";

export const VALID_COLLECT_REASONS = ["Do Not Collect", "Optional", "Required"] as const satisfies CollectReason[];

export const convertStringToCollectReason = (str: string): CollectReason | undefined =>
  VALID_COLLECT_REASONS.find((reason) => reason === str);
